import * as React from 'react';
import { GameLaunchStrategies } from '../../types/gameTypes';
import { CallbackMode } from '../../logic/main/types';

export const DEFAULT_GAME_STRATEGY = 'default';

export const LaunchStrategiesContext = React.createContext<{
  launchStrategies: GameLaunchStrategies;
  callbackMode: CallbackMode;
}>({ launchStrategies: {}, callbackMode: 'event' });

interface LaunchStrategiesProviderPropTypes {
  children?: React.ReactNode;
  launchStrategies: GameLaunchStrategies;
  callbackMode?: CallbackMode;
  visible?: boolean;
}

export const LaunchStrategiesProvider: React.FC<LaunchStrategiesProviderPropTypes> = ({
  children,
  visible = true,
  launchStrategies,
  callbackMode = 'event',
}) => {
  if (!visible) return null;
  return (
    <LaunchStrategiesContext.Provider
      value={{ launchStrategies, callbackMode }}
    >
      {children}
    </LaunchStrategiesContext.Provider>
  );
};
